import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const workReportApi = createApi({
  reducerPath: "/core/work/report",
  baseQuery: axiosBaseQuery,
  tagTypes: ["workList"],
  endpoints: (builder) => ({
    workReportFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
      providesTags: ['workList'],
      query: (query = '') => ({
        url: "/core/work/report" + query,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        console.log('=api response=', response)
        return {
          data: response.data,
          pagination: response?.pagination,
        };
      },
    }),

    workReportCreate: builder.mutation({
      invalidatesTags: ['workList'],
      query: (data) => ({
        url: `/core/work/report/`,
        method: "POST",
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    }),
    workReportUpdate: builder.mutation({
      invalidatesTags: ['workList'],
      query: (data) => ({
        url: `/core/work/report/${data.get('id')}`,
        method: "PUT",
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
    }),

    workReportDelete: builder.mutation({
      invalidatesTags: ['workList'],
      query: (id) => ({ url: "/core/work/report/" + id, method: "DELETE" })
    }),
    workReportFindOne: builder.query<{ data: {} }, any | void>({
      query: (id: any) => ({
        url: "/core/work/report/" + id,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return {
          data: response.data,
        };
      },
    }),
  })
})

export const { useWorkReportFindAllQuery, useWorkReportFindOneQuery, useWorkReportCreateMutation, useWorkReportUpdateMutation, useWorkReportDeleteMutation } = workReportApi;
export { workReportApi };
